<template>
    <a
        href="https://www.paulaschoice.com.tw/linebinding-step1.php?source=pixnet"
        target="_blank"
        class="getSamples"
        @click="gtagEvent('https://www.paulaschoice.com.tw/linebinding-step1.php?source=pixnet', '按鈕點擊', '免費領取試用')"
    >
        <img
            src="@/assets/images/getSamples__top.png"
            class="rwdimg paula animate__animated animate__pulse animate__infinite animate__slow"
            alt="免費領取試用"
            loading="lazy"
        />
        <img
            src="@/assets/images/getSamples__bottom.png"
            class="rwdimg"
            alt="免費領取試用"
            loading="lazy"
        />
    </a>
</template>

<script setup>
import gtagEvent from '@/assets/js/gtag';
</script>

<style lang="scss" scoped>
@import '@/styles/getSamples';
</style>
